import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  alignRight: function alignRight() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: flex;\n      flex-direction: row-reverse;\n    "])));
  }
});